import type { ReactElement, ReactNode } from 'react';
import React from 'react';
import type {
  TextStyle,
  StyleProp,
  TextProps as RNTextProps,
} from 'react-native';
import { StyleSheet, Text as RNText } from 'react-native';

import { getAdjustedFontFamilyStyles } from './BaseText.helpers';
import { TYPE_CONFIG, COLORS } from '@garnish/constants';
import type { SGTextStyle } from './BaseText.types';

export type BaseTextProps = {
  readonly children: ReactNode;
  readonly style?: StyleProp<SGTextStyle | TextStyle>;
} & Omit<RNTextProps, 'style'>;

export const BaseText = React.forwardRef(
  (props: BaseTextProps, ref: React.Ref<RNText>): ReactElement<RNText> => {
    const { style, children, ...rest } = props;

    const fontFamStyles = getAdjustedFontFamilyStyles([styles.base, style]);

    return (
      <RNText ref={ref} style={fontFamStyles as StyleProp<TextStyle>} {...rest}>
        {children}
      </RNText>
    );
  },
);

const styles = StyleSheet.create({
  base: {
    ...TYPE_CONFIG.BODY['18'],
    color: COLORS.DARK_KALE,
  },
});
